<script setup>
import { computed } from 'vue';
import MinuteField from 'dashboard/components-next/time/MinuteField.vue';
import Select from 'dashboard/components-next/select/Select.vue';
const props = defineProps({
  modelValue: { type: String, default: '09:00' },
  label: { type: String, required: true },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);
const options = count =>
  Array.from({ length: count }, (_, index) => {
    const value = String(index).padStart(2, '0');
    return { value, label: value };
  });
const separator = ':';
const hours = options(24);
const hour = computed(() => props.modelValue.split(':')[0] || '09');
const minute = computed(() =>
  props.modelValue.includes(':') ? props.modelValue.split(':')[1] : '00'
);
const update = (part, value) => {
  if (props.disabled) return;
  emit(
    'update:modelValue',
    part === 'hour' ? `${value}:${minute.value}` : `${hour.value}:${value}`
  );
};
</script>

<template>
  <fieldset class="m-0 min-w-0 border-0 p-0" :disabled="disabled">
    <legend class="mb-1.5 text-sm font-medium text-n-slate-12">
      {{ label }}
    </legend>
    <div class="flex items-center gap-1">
      <Select
        :model-value="hour"
        :options="hours"
        :aria-label="`${label}: hora`"
        :disabled="disabled"
        class="min-w-0 flex-1 [&>select]:w-full"
        data-testid="time-hour"
        @update:model-value="update('hour', $event)"
      />
      <span aria-hidden="true">{{ separator }}</span>
      <MinuteField
        :model-value="minute"
        :label="`${label}: minutos`"
        :disabled="disabled"
        class="min-w-0 flex-1"
        data-testid="time-minute"
        @update:model-value="update('minute', $event)"
      />
    </div>
  </fieldset>
</template>
